export default import.meta.ROLLUP_FILE_URL_v9ScvBytvvLWsyz1BxHekw